module.exports = __webpack_public_path__ + "media/images/admin/icons/wind-d2a4a1fe8ac82ef136c5d7163b075554.svg";